import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Vue from "vue";
import moment from 'moment';

const CampaignRepository = RepositoryFactory.get('campaigns');

// initial state
// shape: [{ id, quantity }]
const state = {
    campaign: {
        id: null,
        name: null,
        department: '',
        status: 'in Arbeit',
        contact_person: null,
        jira_ticket_url: null,
        customer: null,
        ad_special_id: null,
        ad_special: {name: ''},
        mediums: [
            {
                id: null,
                name: null,
                type: 'Online',
                status: 'in Arbeit',
                insertion_order: [],
                active: true,
                tracking_list_id: null
            }
        ]
    },
    deletedMediums: [],
    deletedInsertionOrders: [],
    editMode: false,
    changesMade: false,
    lineItemChanges: false,
    automaticLineItemRetrieve: true,
    created_at: null
};

// getters
const getters = {
    mediums: (state) => {
        let tmp = [];
        for (let i = 0; i < state.campaign.mediums.length; i++) {
            let icon = state.campaign.mediums[i].type.toLowerCase() === 'online' ? 'icon-device-xdigital' : (state.campaign.mediums[i].type.toLowerCase() === 'tablet' ? 'icon-device-tablet' : (state.campaign.mediums[i].type.toLowerCase() === 'desktop' ? 'icon-device-desktop' : 'icon-device-mobile'));
            tmp.push({
                itemComponentName: "Medium",
                itemComponentProps: {
                    active: true,
                    id: state.campaign.mediums[i].id,
                    name: state.campaign.mediums[i].name,
                    type: state.campaign.mediums[i].type,
                    componentType: 'Medium',
                    status: state.campaign.mediums[i].tracking_list ? state.campaign.mediums[i].tracking_list.status : null,
                    statusVisible: state.campaign.mediums[i].tracking_list_id !== null,
                    copyAllowed: false
                },
                icon: icon,
                status: state.campaign.mediums[i].tracking_list ? state.campaign.mediums[i].tracking_list.status : null,
                statusVisible: state.campaign.mediums[i].tracking_list_id !== null
            });
        }
        return tmp;
    },
    insertionOrdersSorted: (state) => (mediumIndex) => {
        let ret = {
            'roc': [],
            'ros': [],
            'fp': []
        };
        let orders = state.campaign.mediums[mediumIndex].insertion_order;
        for (let i = 0; i < orders.length; i++) {
            orders[i]['index'] = i;
            switch (orders[i].type) {
                case 'Run of Channel':
                    ret['roc'].push(orders[i]);
                    break;
                case 'Run of Site':
                    ret['ros'].push(orders[i]);
                    break;
                case 'Festplatzierung':
                    ret['fp'].push(orders[i]);
                    break;

            }
        }

        if (ret['roc'].length === 0) {
            let blueprint1 = {
                type: 'Run of Channel',
                sites: [],
                dates: [],
                dashboard_dates: [],
                creatives: [],
                line_items: [],
                index: state.campaign.mediums[mediumIndex].insertion_order.length
            };
            state.campaign.mediums[mediumIndex].insertion_order.push(blueprint1);
            ret['roc'].push(blueprint1);
        }
        if (ret['ros'].length === 0) {
            let blueprint2 = {
                type: 'Run of Site',
                sites: [],
                dates: [],
                dashboard_dates: [],
                creatives: [],
                line_items: [],
                index: state.campaign.mediums[mediumIndex].insertion_order.length
            };
            state.campaign.mediums[mediumIndex].insertion_order.push(blueprint2);
            ret['ros'].push(blueprint2);
        }
        if (ret['fp'].length === 0) {
            let blueprint3 = {
                type: 'Festplatzierung',
                sites: [],
                dates: [],
                dashboard_dates: [],
                creatives: [],
                line_items: [],
                index: state.campaign.mediums[mediumIndex].insertion_order.length
            };
            state.campaign.mediums[mediumIndex].insertion_order.push(blueprint3);
            ret['fp'].push(blueprint3);
        }

        return ret;
    }
};

// actions
const actions = {
    async fetch({commit, state}, id) {
        const {data} = await CampaignRepository.getCampaign(id, true);
        if (data.constructor === Object && Object.keys(data).length !== 0) {
            state.editMode = true;
            commit('setCampaign', {campaign: data});
            state.changesMade = false;
        }
    },
    async save({state}, vm) {
        //delete empty insertion orders and mediums
        let valid = true;

        if (!state.campaign.customer || state.campaign.customer === '') {
            vm.$noty.error('Es muss ein Kunde angegeben werden');
            valid = false;
        }

        if (!state.campaign.department || state.campaign.department === '') {
            vm.$noty.error('Es muss eine Abteilung angegeben werden');
            valid = false;
        }

        if (!state.campaign.name || state.campaign.name === '') {
            vm.$noty.error('Es muss ein Kampagnenname angegeben werden');
            valid = false;
        }

        if (!state.campaign.ad_special_id || state.campaign.ad_special_id === '') {
            vm.$noty.error('Es muss ein AdSpecial angegeben werden');
            valid = false;
        }

        if (valid) {
            for (let i = 0; i < state.campaign.mediums.length; i++) {
                for (let j = 0; j < state.campaign.mediums[i].insertion_order.length; j++) {
                    let current = state.campaign.mediums[i].insertion_order[j];
                    if (current.sites.length === 0 && current.dates.length === 0 && current.creatives.length === 0 && current.line_items.length === 0) {
                        state.campaign.mediums[i].insertion_order.splice(j, 1);
                        j--;
                    }
                }
                if (!valid) {
                    break;
                }
                if (state.campaign.mediums[i].insertion_order.length === 0) {
                    state.campaign.mediums.splice(i, 1);
                    i--;
                }
            }
        }

        if (state.campaign.mediums.length === 0) {
            valid = false;
            vm.$noty.error('Es muss mindestens ein Medium angegeben werden');
        }

        let ret = false;
        if (valid) {
            let json = JSON.stringify(state.campaign);
            let json2 = JSON.parse(json);
            json2.automaticLineItemRetrieve = state.automaticLineItemRetrieve;
            try {
                ret = await CampaignRepository.create(json2);
                vm.$noty.success('Kampagne wurde erfolgreich erstellt');
                state.changesMade = false;
                vm.$router.push({name: 'campaigns'});
            } catch (e) {
                vm.$noty.error(e.message);
                vm.$log.error(e);
            }

        }
        return ret;
    },
    async updateLinkState({commit}, payload) {
        try {
            await CampaignRepository.updateCampaign(payload.id, {extern_link_is_active: payload.active});
            Vue.noty.success('Aktualisierung erfolgreich');
            commit('setActiveLink', payload.active);
        } catch (e) {
            console.log(e);
            Vue.noty.error(e);
        }
    },
    async update({state,commit}, payload) {
        let valid = true;
        if (typeof payload.type !== "undefined" && payload.type === "saveDashboard") {
            state.campaign.comment = payload.data.comment;
            try {
                CampaignRepository.updateCampaign(payload.id, state.campaign);
            } catch (e) {
                console.log(e);
            }
        } else {
            //delete empty insertion orders and mediums
            let vm = payload.vm;
            if(typeof payload.forceAdManagerSync !== 'undefined' && payload.forceAdManagerSync && state.automaticLineItemRetrieve){
                state.lineItemChanges = true;
            }
            if (!state.campaign.customer || state.campaign.customer === '') {
                vm.$noty.error('Es muss ein Kunde angegeben werden');
                valid = false;
            }

            if (!state.campaign.department || state.campaign.department === '') {
                vm.$noty.error('Es muss eine Abteilung angegeben werden');
                valid = false;
            }

            if (!state.campaign.name || state.campaign.name === '') {
                vm.$noty.error('Es muss ein Kampagnenname angegeben werden');
                valid = false;
            }

            if (!state.campaign.ad_special_id || state.campaign.ad_special_id === '') {
                vm.$noty.error('Es muss ein AdSpecial angegeben werden');
                valid = false;
            }

            if (valid) {
                for (let i = 0; i < state.campaign.mediums.length; i++) {
                    for (let j = 0; j < state.campaign.mediums[i].insertion_order.length; j++) {
                        let current = state.campaign.mediums[i].insertion_order[j];
                        if (current.sites.length === 0 && current.dates.length === 0 && current.creatives.length === 0 && current.line_items.length === 0) {
                            state.campaign.mediums[i].insertion_order.splice(j, 1);
                            j--;
                        }
                    }
                    if (!valid) {
                        break;
                    }
                    if (state.campaign.mediums[i].insertion_order.length === 0) {
                        state.campaign.mediums.splice(i, 1);
                        i--;
                    }
                }
            }

            if (state.campaign.mediums.length === 0) {
                valid = false;
                vm.$noty.error('Es muss mindestens ein Medium angegeben werden');
            }

            let ret = false;
            if (valid) {
                let json = JSON.stringify(state.campaign);
                let json2 = JSON.parse(json);
                json2.automaticLineItemRetrieve = state.automaticLineItemRetrieve;
                json2.deletedMediums = state.deletedMediums;
                json2.deletedInsertionOrders = state.deletedInsertionOrders;
                json2.lineItemChanges = state.lineItemChanges;
                try {
                    ret = await CampaignRepository.updateCampaign(payload.id, json2);
                    if(ret.data.status === 'updated'){
                        commit('setCampaign', {campaign: ret.data.campaign});
                        vm.$noty.success('Kampagne wurde erfolgreich gespeichert');
                    }else{
                        vm.$noty.error('Kampagne konnte nicht gespeichert werden');
                    }

                    state.changesMade = false;
                } catch (e) {
                    vm.$noty.error('Es ist ein Fehler aufgetreten');
                    console.log(e);
                    vm.$noty.error('Die Kampagne konnte nicht aktualisiert werden: ' + e.message);
                }

            }
            return ret;
        }
    }
};

// mutations
const mutations = {
    setActiveLink(state, active) {
        state.campaign.extern_link_is_active = active;
    },
    setCampaign(state, {campaign}) {
        state.campaign = campaign;
        state.changesMade = false;
    },
    setId(state, id) {
        state.campaign.id = id;
    },
    setAdSpecialId(state, id) {
        state.changesMade = true;
        state.campaign.ad_special_id = id;
    },
    initAdSpecial(state, id) {
        state.campaign.ad_special_id = id;
    },
    setName(state, name) {
        state.changesMade = true;
        state.campaign.name = name;
    },
    setCustomer(state, customer) {
        state.changesMade = true;
        state.campaign.customer = customer;
    },
    setDepartment(state, department) {
        state.changesMade = true;
        state.campaign.department = department;
    },
    setJiraLink(state, jiraLink) {
        state.changesMade = true;
        state.campaign.jira_ticket_url = jiraLink;
    },
    setPerson(state, person) {
        state.changesMade = true;
        state.campaign.contact_person = person;
    },
    changeMediumName(state, payload) {
        state.changesMade = true;
        state.campaign.mediums[payload.index].name = payload.name;
    },
    addInsertionOrder(state, payload) {
        state.changesMade = true;
        state.campaign.mediums[payload.index].insertion_order.push({
            type: payload.type,
            sites: [],
            dates: [],
            dashboard_dates: [],
            creatives: [],
            line_items: []
        });
    },
    addMedium(state) {
        state.changesMade = true;
        state.campaign.mediums.push({
            id: null,
            name: null,
            type: 'Online',
            status: 'in Arbeit',
            insertion_order: [],
            active: true
        })
    },
    deleteMedium(state, index) {
        state.changesMade = true;
        if (typeof state.campaign.mediums[index].id !== 'undefined') {
            state.deletedMediums.push(state.campaign.mediums[index]);
        }
        return state.campaign.mediums.splice(index, 1);
    },
    deviceTypeChange(state, payload) {
        state.changesMade = true;
        state.campaign.mediums[payload.index].type = payload.type;
    },
    addRange(state, payload) {
        let ranges = state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].dates;
        let start = moment(payload.range.start);
        let end = moment(payload.range.end);
        if (!start.isValid() || !end.isValid()) {
            return;
        }
        for (let i = 0; i < ranges.length; i++) {
            let start1 = moment(ranges[i].start);
            let end1 = moment(ranges[i].end);
            if (start.isSame(start1,'date') && end.isSame(end1,'date')) {
                return;
            }
        }
        payload.range.start = start.format('YYYY-MM-DD');
        payload.range.end = end.format('YYYY-MM-DD');
        if(typeof payload.dashboard_dates !== 'undefined' && payload.dashboard_dates === true){
            state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].dashboard_dates.push(payload.range);
        }else{
            state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].dates.push(payload.range);
        }

        state.changesMade = true;
    },
    addCreativeId(state, payload) {
        state.changesMade = true;
        state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].creatives.push({admanager_id: payload.id});
    },
    addLineItemId(state, payload) {
        state.changesMade = true;
        state.lineItemChanges = true;
        state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].line_items.push({admanager_id: payload.id});
    },
    addSite(state, payload) {
        state.changesMade = true;
        state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].sites.push(payload.site);
    },
    removeSite(state, payload) {
        let sites = state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].sites;
        sites.splice(payload.siteIndex, 1);
        state.changesMade = true;
    },
    removeRange(state, payload) {
        let ranges = null;
        if(typeof payload.dashboard_dates !== 'undefined' && payload.dashboard_dates === true){
            ranges = state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].dashboard_dates;
        }else{
            ranges = state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].dates;
        }
        for (let i = 0; i < ranges.length; i++) {
            let range = payload.range.split('-');
            let start = moment(range[0],'DD.MM.YYYY');
            let end = moment(range[1],'DD.MM.YYYY');
            let start1 = moment(ranges[i].start,'YYYY-MM-DD');
            let end1 = moment(ranges[i].end,'YYYY-MM-DD');
            if (start.isSame(start1,'day')&& end.isSame(end1,'day')) {
                ranges.splice(i, 1);
                state.changesMade = true;
                break;
            }
        }
    },
    removeCreative(state, payload) {
        let creatives = state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].creatives;
        for (let i = 0; i < creatives.length; i++) {
            if (creatives[i].admanager_id === payload.creative) {
                creatives.splice(i, 1);
                state.changesMade = true;
                break;
            }
        }
    },
    removeLineItem(state, payload) {
        let lineItems = state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].line_items;
        for (let i = 0; i < lineItems.length; i++) {
            if (lineItems[i].admanager_id === payload.lineItem) {
                lineItems.splice(i, 1);
                state.lineItemChanges = true;
                state.changesMade = true;
                break;
            }
        }
    },
    deleteInsertionOrder(state, payload) {
        state.changesMade = true;
        if (typeof state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index].id !== 'undefined') {
            state.deletedInsertionOrders.push(state.campaign.mediums[payload.mediumIndex].insertion_order[payload.index]);
        }
        return state.campaign.mediums[payload.mediumIndex].insertion_order.splice(payload.index, 1);
    },
    deleteTrackingList(state, id) {
        state.changesMade = true;
        let medium = state.campaign.mediums.find(x => x.tracking_list_id === id);
        medium.tracking_list_id = null;
        medium.tracking_list = null;
    },
    changeActiveState(state, payload) {
        state.campaign.mediums[payload.index].active = payload.active;
    },
    changeAutomaticMode(state, payload) {
        state.automaticLineItemRetrieve = payload.automaticLineItemRetrieve;
    },
    resetCampaign(state) {
        state.editMode = false;
        state.automaticLineItemRetrieve = true;
        state.campaign = {
            id: null,
            name: null,
            department: null,
            status: 'in Arbeit',
            contact_person: null,
            jira_ticket_url: null,
            customer: null,
            ad_special_id: null,
            mediums: [
                {
                    id: null,
                    name: null,
                    type: 'Online',
                    status: 'in Arbeit',
                    insertion_order: [],
                    active: true,
                    tracking_list_id: null
                }
            ],
            created_at:null
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}